import { format } from 'date-fns';

export const formatDate = (date?: Date) => {
  if (!date) {
    return '';
  }

  return format(date, 'yyyy-MM-dd');
};

export const booleanToString = (value: boolean) => {
  return value ? '1' : '0';
};

export const stringToBoolean = (value: string) => {
  return value === '1';
};

export const userHasAccessToDevelopmentFeature = (email: string) => {
  const allowedEmails = /^.*@(ventie30.it|groupeseb.com|btwofactory.com)$/;

  return allowedEmails.test(email);
};
